import { Component, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import {
    ChartComponent,
    ApexNonAxisChartSeries,
    ApexResponsive,
    ApexChart,
    ApexTitleSubtitle,
    ApexFill,
    ApexStroke,
    ApexYAxis,
    ApexLegend,
    ApexPlotOptions,
    NgApexchartsModule,
    ApexTooltip,
} from 'ng-apexcharts';
import { TranslocoModule } from '@ngneat/transloco';

export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    responsive: ApexResponsive[];
    labels: any;
    title: ApexTitleSubtitle;
    fill: ApexFill;
    tooltip: ApexTooltip;
    yaxis: ApexYAxis;
    stroke: ApexStroke;
    legend: ApexLegend;
    colors: string[];
    plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-vulnerability-breakdown',
  standalone: true,
  imports: [
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    NgApexchartsModule,
    TranslocoModule,
  ],
  templateUrl: './vulnerability-breakdown.component.html',
  styleUrl: './vulnerability-breakdown.component.scss'
})
export class VulnerabilityBreakdownComponent {
@ViewChild('chart') chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    @Input() data: number[] = [0,0,0,0,0,0];

    constructor() {
        this.chartOptions = {
            series: this.data,
            chart: {
                height: 400,
                type: 'donut',
                toolbar: {
                    show: true
                }
            },
            labels: ['Critical', 'High', 'Medium', 'Low', 'Info', 'Unknown'],
            fill: {
                opacity: 1,
            },
            stroke: {
                width: 1,
                colors: undefined,
            },
            colors: ['#D50000', '#F44336', '#FF6D00', '#FFD600', '#2962FF', '#03A9F4'],
            yaxis: {
                show: false,
            },
            legend: {
                offsetY: -10,
                fontSize: '14px',
                position: 'bottom',
                horizontalAlign: 'center',
                labels: {
                    colors: '#919aa3',
                },
                itemMargin: {
                    horizontal: 12,
                    vertical: 7,
                },
                formatter: function(seriesName, opts) {
                    return seriesName + " - " + opts.w.globals.series[opts.seriesIndex]
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            name: {
                                show: true,
                            },
                            value: {
                                show: true,
                            },
                            total: {
                                show: true,
                                showAlways: true,
                            },
                        },
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + '';
                    },
                },
            },
        };
    }

    // changeData
    changeData() {
        this.chartOptions.series = this.data;
    }
}
